import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getVPCLocations({ page = 1, pageSize = 10, filter = "", sorting }) {
  const currentPage = page - 1;
  const SkipCount = currentPage * pageSize;
  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    sorting: sorting ?? undefined,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vpc-locations`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getVPCLocationById(vpcLocationId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vpc-locations/${vpcLocationId}`, {
    method: "GET",
  });

  return result?.data;
}
